import { Empty, Icon } from 'ui';
import { useDebounce } from 'common/hooks';
import { EntityList } from 'features/channels';
import { useOrganizationsInfiniteQuery } from 'features/organizations';

type P = {
  getPathToOrganizationDetail: (id: string) => string;
  memberId: string;
  search?: string;
};

const MemberOrganizationsList = ({ getPathToOrganizationDetail, memberId, search: propertySearch }: P) => {
  const { isDebouncing, value: search } = useDebounce(propertySearch);
  const {
    data: allOrganizationsData,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingAll,
    isLoading: isLoadingAll,
  } = useOrganizationsInfiniteQuery({
    filter: { scope: 'joined', search, userId: memberId },
    pagination: { pageSize: 12 },
  });

  const allOrganizations = allOrganizationsData?.pages
    .flat()
    .flatMap((organizationsPaginated) => organizationsPaginated.data);

  return (
    <EntityList
      empty={
        <Empty
          description={{
            subtitle: 'There are no organizations to display here',
            title: 'No organizations',
          }}
          image={<Icon icon="bank-line" />}
        />
      }
      entities={allOrganizations?.map((organization) => ({
        data: organization,
        type: 'Organization',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToOrganizationDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetchingAll}
      isLoading={isLoadingAll || isDebouncing}
    />
  );
};

export default MemberOrganizationsList;
